<script>
	import Countdown from "./Countdown.svelte";
	import Visite from "./Visite.svelte";
</script>

<style>
</style>

<main>
	<Countdown />
	<Visite />
</main>